import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { ComponentTranslationMapping } from '../page-structure/component-translation-mapping-models';
import { PageStructure } from '../page-structure/page-structure-models';

@Injectable({ providedIn: 'root' })
export class PageStructureService {
    private currentPageStructure: PageStructure;
    private pageStructureSubject: ReplaySubject<PageStructure>;

    constructor() {
        this.currentPageStructure = {
            header: null,
            footer: null,
            pageTranslations: null,
            components: [],
        };
        this.pageStructureSubject = new ReplaySubject<PageStructure>(1);
    }

    setHeaderStructure(header: ComponentTranslationMapping): void {
        this.currentPageStructure.header = header;
        this.pageStructureSubject.next(this.currentPageStructure);
    }

    setFooterStructure(footer: ComponentTranslationMapping): void {
        this.currentPageStructure.footer = footer;
        this.pageStructureSubject.next(this.currentPageStructure);
    }

    setCurrentPageStructure(pageTranslations: ComponentTranslationMapping, components: ComponentTranslationMapping[]): void {
        this.currentPageStructure.pageTranslations = pageTranslations;
        this.currentPageStructure.components = components;
        this.pageStructureSubject.next(this.currentPageStructure);
    }

    getPageStructureSubject(): Subject<PageStructure> {
        return this.pageStructureSubject;
    }
}
